var titleEls = $('.map-delivery-info__title');

titleEls.on('click', function(){
	var thisEl    = $(this);
	var infoEl    = thisEl.closest('.map-delivery-info');
	var contentEl = infoEl.find('.map-delivery-info__content');

	thisEl.toggleClass('active');
	contentEl.toggle();
});